// extracted by mini-css-extract-plugin
export default {"container":"courseExam_container__Js+is","selected":"courseExam_selected__K+8Im","title":"courseExam_title__4--Dk","cannotGoThere":"courseExam_cannotGoThere__lrtBj"};